import { Outlet } from 'react-router-dom';

import { NavBarProvider } from '@myphx-engineering/phx-design-system';

export const Layout = () => {
    return (
        <NavBarProvider>
            <Outlet />
        </NavBarProvider>
    );
};

export default Layout;
